import { useMemo } from 'react'
import { usePendingTeacherInvitations } from './usePendingTeacherInvitations'
import { useTeacherDirectory } from './useTeacherDirectory'

/**
 * The people who teach at a school: teachers who already have access, and teacher invitations
 * still waiting to be accepted. Both lists are limited to this school.
 */
export function useSchoolTeachingStaff(schoolId: string | undefined) {
  const teachers = useTeacherDirectory({
    query: '',
    schoolId,
    pageSize: 200,
    enabled: Boolean(schoolId),
  })
  const invitations = usePendingTeacherInvitations(schoolId)

  const pending = useMemo(
    () =>
      (invitations.data ?? []).filter(
        invitation =>
          invitation.status === 'PENDING' &&
          (!schoolId || !invitation.school_ids || invitation.school_ids.includes(schoolId)),
      ),
    [invitations.data, schoolId],
  )

  return {
    teachers: teachers.data ?? [],
    pendingInvitations: pending,
    isLoading: teachers.isLoading || invitations.isLoading,
    hasError: Boolean(teachers.error || invitations.error),
    refetch: () => Promise.all([teachers.refetch(), invitations.refetch()]),
  }
}
